var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-logo"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"alt":"Labelcall logo","src":require("assets/logo-small.png")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }